import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import Decimal from 'decimal.js';
import { FeesByEnumDTO, PaymentMethodEnumDTO, PaymentProcessorTypeEnumDTO, RefundStatusTypeEnumDTO } from 'anchor-ts-infra/src/dto/payment/dto';
export class PaymentModel {
    fees() {
        return this.data.fees;
    }
    paymentProcessorType() {
        return this.data.paymentProcessorType;
    }
    isPaymentProcessorColumn() {
        return this.data.paymentProcessorType === PaymentProcessorTypeEnumDTO.Column;
    }
    isPaymentProcessorStripe() {
        return this.data.paymentProcessorType === PaymentProcessorTypeEnumDTO.Stripe;
    }
    isFeesAch() {
        return this.data.fees.type === PaymentMethodEnumDTO.Ach;
    }
    isFeesCreditCard() {
        return this.data.fees.type === PaymentMethodEnumDTO.CreditCard;
    }
    creditCardFees() {
        return this.data.fees.type === PaymentMethodEnumDTO.CreditCard ? this.data.fees.creditCard : null;
    }
    isVendorFees() {
        return this.data.fees.type === PaymentMethodEnumDTO.CreditCard && this.data.fees.creditCard.feesBy === FeesByEnumDTO.Vendor;
    }
    isCustomerFees() {
        return this.data.fees.type === PaymentMethodEnumDTO.CreditCard && this.data.fees.creditCard.feesBy === FeesByEnumDTO.Customer;
    }
    remainingAmount() {
        const successfulRefunds = this.successfulRefunds() || [];
        return successfulRefunds.length > 0 ? new Decimal(successfulRefunds[successfulRefunds.length - 1].amounts.remainingAmount).div(100) : null;
    }
    refunds() {
        return this.data.refunds;
    }
    successfulRefunds() {
        return this.data.refunds && this.data.refunds.filter((r)=>r.refundStatus === RefundStatusTypeEnumDTO.Refunded);
    }
    totalRefunded() {
        const successfulRefunds = this.successfulRefunds();
        return successfulRefunds ? successfulRefunds.reduce((acc, refund)=>acc.add(new Decimal(refund.amounts.refundAmount).div(100)), new Decimal(0)).add(successfulRefunds.reduce((acc, refund)=>acc.add(new Decimal(refund.amounts.refundFees).div(100)), new Decimal(0))).toFixed(2).replace(/\.00$/, '') : '0';
    }
    hasRefundFees() {
        const successfulRefunds = this.successfulRefunds() || [];
        return successfulRefunds.some((refund)=>refund.amounts.refundFees > 0);
    }
    addRefund(refund) {
        return new PaymentModel(_object_spread_props(_object_spread({}, this.data), {
            refunds: [
                ...this.data.refunds || [],
                refund
            ]
        }));
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
